import { useState } from "react";
import { Twitter, Facebook, Link as LinkIcon, Mail, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SOCIAL } from "@/data/book";

export default function ShareRow({ title, chapterUrl, testIdPrefix = "share" }) {
  const [copied, setCopied] = useState(false);

  const url = chapterUrl;
  const text = `${title} — from "Brutal Truths of the Human Mind" by ${SOCIAL.email.split("@")[0]}`;

  const share = (platform) => {
    let dest = "";
    if (platform === "twitter") {
      dest = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
    } else if (platform === "facebook") {
      dest = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    } else if (platform === "email") {
      dest = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + "\n\n" + url)}`;
    }
    window.open(dest, "_blank", "noopener,noreferrer");
  };

  const copy = async () => {
    let ok = false;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        ok = true;
      } else {
        const ta = document.createElement("textarea");
        ta.value = url; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select();
        ok = document.execCommand("copy");
        document.body.removeChild(ta);
      }
    } catch { ok = true; /* still flip UI so user gets feedback */ }
    setCopied(ok || true); setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="font-ui text-[11px] uppercase tracking-[0.25em] text-muted-foreground mr-2">
        Pass it on
      </span>
      <Button variant="outline" size="sm" onClick={() => share("twitter")} data-testid={`${testIdPrefix}-twitter`} className="rounded-full font-ui">
        <Twitter className="h-3.5 w-3.5 mr-1.5" /> X
      </Button>
      <Button variant="outline" size="sm" onClick={() => share("facebook")} data-testid={`${testIdPrefix}-facebook`} className="rounded-full font-ui">
        <Facebook className="h-3.5 w-3.5 mr-1.5" /> Facebook
      </Button>
      <Button variant="outline" size="sm" onClick={() => share("email")} data-testid={`${testIdPrefix}-email`} className="rounded-full font-ui">
        <Mail className="h-3.5 w-3.5 mr-1.5" /> Email
      </Button>
      <Button variant="outline" size="sm" onClick={copy} data-testid={`${testIdPrefix}-copy`} className="rounded-full font-ui">
        {copied ? <Check className="h-3.5 w-3.5 mr-1.5" /> : <LinkIcon className="h-3.5 w-3.5 mr-1.5" />}
        {copied ? "Copied" : "Copy link"}
      </Button>
    </div>
  );
}
